export enum Status {
  Idle,
  Loading,
  Error,
  Success
}
